"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ConsoleLoggingService_1 = require("./ConsoleLoggingService");
var LoggingStorageService = /** @class */ (function () {
    function LoggingStorageService(opts) {
        this._target = opts.target;
        this._prefix = opts.prefix;
        this._logger = opts.logger || ConsoleLoggingService_1.ConsoleLoggingService;
    }
    LoggingStorageService.prototype.getItem = function (key) {
        var _this = this;
        return this._target.getItem(key).then(function (item) {
            _this._logger.info("-- " + _this._prefix + ": Got Item for " + key + ": " + JSON.stringify(item));
            return item;
        }).catch(function (error) {
            _this._logger.warn("-- " + _this._prefix + ": Error getting item for key " + key + ": " + error);
        });
    };
    LoggingStorageService.prototype.setItem = function (key, item) {
        var _this = this;
        this._logger.info("-- " + this._prefix + ": Setting Item for " + key + ": " + JSON.stringify(item));
        return this._target.setItem(key, item).catch(function (error) {
            _this._logger.warn("-- " + _this._prefix + ": Error setting item for key " + key + ": " + error);
            return Promise.reject(error);
        });
    };
    LoggingStorageService.prototype.removeItem = function (key) {
        var _this = this;
        this._logger.info("-- " + this._prefix + ": Removing Item for " + key);
        return this._target.removeItem(key).catch(function (error) {
            _this._logger.warn("-- " + _this._prefix + ": Error removing item for key " + key + ": " + error);
            return Promise.reject(error);
        });
    };
    return LoggingStorageService;
}());
exports.LoggingStorageService = LoggingStorageService;
